import { Component, ViewChild, AfterViewChecked, OnDestroy } from '@angular/core';

import { CustomNavController } from 'src/shared/providers/navigation/custom-nav-controller';
import { WindowService } from 'src/shared/providers/window.service';
import { UnifiedAgentPage } from 'src/pages/unified-agent/unified-agent';

@Component({
  templateUrl: 'mobile-agent-triggers.page.html',
  standalone: false,
})
export class MobileAgentTriggersPage implements AfterViewChecked, OnDestroy {

  @ViewChild(UnifiedAgentPage) unifiedAgent: UnifiedAgentPage;

  private lastLoadingState: boolean | null = null;

  constructor(
    private navCtrl: CustomNavController,
    private windowService: WindowService,
  ) {}

  get isLoading(): boolean {
    return !this.unifiedAgent?.loaded || !!this.unifiedAgent?.showLoadingSpinner;
  }

  // Toggle the top-nav's built-in .js-tidy-loading bar while this page is
  // loading — matches the pattern used by src/pages/chat/chat.page.ts.
  ngAfterViewChecked() {
    if (this.windowService.isDesktopRes) {
      return;
    }
    const current = this.isLoading;
    if (current === this.lastLoadingState) {
      return;
    }
    this.lastLoadingState = current;
    const bars = document.querySelectorAll('.js-tidy-loading') as NodeListOf<HTMLElement>;
    bars.forEach(bar => bar.style.display = current ? 'block' : 'none');
  }

  ngOnDestroy() {
    if (!this.windowService.isDesktopRes) {
      const bars = document.querySelectorAll('.js-tidy-loading') as NodeListOf<HTMLElement>;
      bars.forEach(bar => bar.style.display = 'none');
    }
  }

  onTriggerSelected(trigger: { key: string }) {
    const key = encodeURIComponent(trigger.key);
    this.navCtrl.navigateForward(`agent/triggers/${key}`);
  }
}
